import CryptoJS from 'crypto-js';

import getKey from './keys';
import { Source } from './interfraces';

export default function (invitation: string, source?: Source): string {
    return CryptoJS.AES.encrypt(invitation, getKey(source)).toString();
}
